// extracted by mini-css-extract-plugin
module.exports = {"labelInfo":"Label_labelInfo__RYimV","pointer":"Label_pointer__N_LA6","fileLabel":"Label_fileLabel__0CYd1"};